<template>
  <div>
    <h2>Welcome to Telegram Login</h2>
    <div ref="telegramLogin"></div>
    <p v-if="userInfo">User Info: {{ userInfo }}</p>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { WebApp } from '@twa-dev/sdk';
import TelegramAnalytics from '@telegram-apps/analytics';

const userInfo = ref(null);

// Initialize Telegram Analytics
TelegramAnalytics.init({
  token: 'eyJhcHBfbmFtZSI6Imx1ZG9fbGVnZW5kIiwiYXBwX3VybCI6Imh0dHBzOi8vdC5tZS9MdWRvTGVnZW5kX25nX2JvdCIsImFwcF9kb21haW4iOiJodHRwczovL2x1ZG8udGVsZWdyYW0ubmFnb3Jpay50ZWNoIn0=!9aCZijSK4AGMoNhWdsyuH0UyVj36qnUzsMvVs6+nL5o=',
  appName: 'ludo_legend'
});

// Function to get user data from Telegram WebApp SDK
const getTelegramUserData = () => {
  const tg = WebApp;
  const userData = tg.initDataUnsafe?.user || tg.initData?.user;

  if (userData) {
    userInfo.value = userData;
    console.log('Telegram User Data:', userData);

    // Convert the user info to a JSON string
    const userJson = JSON.stringify({
      userId: userData.id,
      firstName: userData.first_name,
      lastName: userData.last_name,
      username: userData.username
    });

    // Now, send this JSON string to Unity using SendMessage
    if (window.unityInstance) {
      window.unityInstance.SendMessage("TelegramManager", "ReceiveTelegramData", userJson);

      // Hide the Vue container and show the Unity container
      document.getElementById('vue-container').style.display = 'none';
      document.getElementById('unity-container').style.display = 'block';
    }
  } else {
    console.log('No user data found');
  }
};

// Lifecycle hook to run the function when the component is mounted
onMounted(() => {
  getTelegramUserData(); // Call to retrieve Telegram user data
});
</script>

<style scoped>
/* Your custom styles for the component */
</style>
